import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { gettext, translationPropType } from '@eb/i18n';
import { Button } from '@eb/eds-button';
import { TYPE_LINK } from '@eb/eds-button';

export class SeeMoreButton extends PureComponent {
    static propTypes = {
        /**
         * Title of parent bucket
         */
        title: PropTypes.oneOfType([PropTypes.string, translationPropType]),
        /**
         * The url the user should be directed to
         */
        linkUrl: PropTypes.string,
        /**
         * The text the button should display
         */
        seeMoreText: PropTypes.string,
        /**
         * Tracking callback for button clicks
         */
        trackClick: PropTypes.func,
        /**
         * String representing user action to send to GA
         */
        gaAction: PropTypes.string,
    };

    static defaultProps = {
        size: 'responsive',
    };

    render() {
        const {
            title,
            linkUrl,
            seeMoreText,
            trackClick,
            gaAction,
            size,
        } = this.props;
        const ariaLabel = seeMoreText
            ? seeMoreText
            : gettext('See more %(title)s', { title });
        const buttonLabel = seeMoreText ? seeMoreText : gettext('See more');

        let component = null;

        if (linkUrl) {
            component = (
                <Button
                    type={TYPE_LINK}
                    href={linkUrl}
                    onClick={trackClick.bind(null, { url: linkUrl }, gaAction)}
                    aria-label={ariaLabel}
                    size={size}
                >
                    {buttonLabel}
                </Button>
            );
        }

        return component;
    }
}
